<template>
  <div class="pageContol studentList">
    <div class="framePage">
      <div class="framePage-title">
        <span>
          <em>当前位置：</em>
          <a href="javascript:;">考试管理</a>
          <i>></i>
          <a href="javascript:;" class="cur-a">考试仓管理</a>
        </span>
      </div>
      <div class="framePage-body">
        <div class="operationControl flexdc" style="align-items: flex-start">
          <div class="searchbox">
            <div title="考试仓名称" class="searchboxItem ci-full">
              <span class="itemLabel" style="min-width: 7em;">考试仓名称:</span>
              <el-input v-model="retrievalData.houseName" type="text" size="small" placeholder="请输入考试仓名称"
                        clearable />
            </div>
            <div title="发布状态" class="searchboxItem ci-full">
              <span class="itemLabel">考试状态:</span>
              <el-select v-model="retrievalData.examState" filterable clearable size="small" placeholder="请选择考试状态">
                <el-option v-for="item in examStateList" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-button type="primary" class="bgc-bv" round @click="getData()">查询</el-button>
            <el-button type="primary" class="bgc-bv" round @click="examHouseEdit()">新增</el-button>
          </div>
        </div>
        <div class="framePage-scroll">
          <div class="ovy-a">
            <el-table ref="multipleTable" :data="tableData" :height="tableHeight" size="small" tooltip-effect="dark"
                      :header-cell-style="tableHeader" stripe>
              <el-table-column label="序号" align="center" type="index" :index="indexMethod" />
              <el-table-column label="考试仓名称" align="left" show-overflow-tooltip prop="houseName" minWidth="200" />
              <el-table-column label="考试状态" align="left" show-overflow-tooltip prop="examState" minWidth="100">
                <template slot-scope="scope">
                  {{ $setDictionary("EXAM_HOUSE_STATE", scope.row.examState) }}
                </template>
              </el-table-column>
              <el-table-column label="通电状态" align="left" show-overflow-tooltip prop="houseState" minWidth="100">
              </el-table-column>
              <el-table-column label="地点" align="left" show-overflow-tooltip prop="address" minWidth="200" />
              <el-table-column label="场地名称" align="left" show-overflow-tooltip prop="areaName" minWidth="200" />
              <!-- <el-table-column label="查看人数" align="left" show-overflow-tooltip prop="lookNum" minWidth="100" >
                <template slot-scope="scope">
                  {{ scope.row.lookNum ? scope.row.lookNum : 0 }}
                </template>
              </el-table-column> -->
              <el-table-column label="操作" align="center" width="200px">
                <template slot-scope="scope">
                  <el-button type="text" style="padding: 0px 5px" size="mini" v-show="scope.row.examState != '00'" @click="resetHouse(scope.row)">复位</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="deviceList(scope.row)">考试设备列表</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="examHouseEdit(scope.row)">编辑</el-button>
                  <el-button type="text" style="padding: 0px 5px" size="mini" @click="examHouseDelete(scope.row)">删除</el-button>
                </template>
              </el-table-column>
              <Empty slot="empty" />
            </el-table>
          </div>
        </div>
        <PageNum :apiData="apiData" @sizeChange="sizeChange" @getData="getData" />
      </div>
    </div>
  </div>
</template>
<script>
import Empty from "@/components/Empty.vue";
import PageNum from "@/components/PageNum.vue";
import List from "@/mixins/List";
export default {
  name: "examination_onlineTest_examHouse",
  components: {
    Empty,
    PageNum,
  },
  mixins: [List],
  data() {
    return {
      // 检索数据
      retrievalData: {
        houseName: "", // 考试仓名称
        examState: "", // 考试状态
      },
      // 发布状态 - 下拉数据
      examStateList: [],
    };
  },
  created() {
    this.dataDictionary();
  },
  watch: {},
  computed: {},
  mounted() { },
  methods: {
    // 获取 - 数据字典
    dataDictionary() {
      // 发布状态
      const examStateList = this.$setDictionary(
          "EXAM_HOUSE_STATE",
          "list"
      );
      const list1 = [];
      for (const key in examStateList) {
        list1.push({
          value: key,
          label: examStateList[key],
        });
      }
      this.examStateList = list1;
    },
    // 获取 - 列表数据
    getData(pageNum = 1) {
      const params = {
        pageNum: pageNum,
        pageSize: this.pageSize,
      };
      if (this.retrievalData.houseName) {
        params.houseName = this.retrievalData.houseName;
      }
      if (this.retrievalData.examState) {
        params.examState = this.retrievalData.examState;
      }
      this.doFetch({
        url: "/biz/isec/exam-house/pageList",
        params,
        pageNum,
      },true,6);
    },
    resetHouse(row) {
      if (row.houseState == 'OFFLINE') {
        this.$message.error("考试仓离线,无法复位,请确认考试仓已正常通电");
        return;
      }
      this.$confirm("你确定复位吗?复位后门禁会重新上锁并立即安排考生进入", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButtonClass",
        cancelButtonText: "取消",
        type: "warning",
      })
      .then(() => {
        this.$post('/biz/isec/exam-house/reset', { examHouseId: row.examHouseId, examAreaId: row.examAreaId }, 3000, true, 6)
            .then((res) => {
              this.$message({
                type: "success",
                message: res.message,
              });
              this.getData(this.pageNum)
            })
            .catch((err) => {
              return;
            });
      })
      .catch(() => {
        return;
      });
    },
    deviceList(row) {
      this.$router.push({
        path: "/web/examination/examHouseDevice",
        query: {
          examHouseId: row.examHouseId, // 考试id
          houseName: row.houseName
        },
      });
    },
    // 操作 - 新增&编辑
    examHouseEdit(row) {
      this.$router.push({
        path: "/web/examination/examHouse/examHouseAddEdit",
        query: {
          examHouseId: row?.examHouseId ?? ''
        }
      });
    },
    // 操作 - 删除
    examHouseDelete(row){
      // 加上是否删除的confirm弹窗
      this.$confirm("是否删除该考试仓?", "提示", {
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButtonClass",
        cancelButtonText: "取消",
        type: "warning",
      })
          .then(() => {
            this.$post('/biz/isec/exam-house/delete', { examHouseId: row.examHouseId }, 3000, true, 6)
                .then((res) => {
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                  this.getData(this.pageNum)
                })
                .catch((err) => {
                  return;
                });
          })
          .catch(() => {
            return;
          });

    }
  },
};
</script>
<style lang="less" scoped></style>
